import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-regular-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';
import moment from 'moment/moment';

//Components
import MainCard from '../../components/MainCard/MainCard';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../components/Modal/Modal';
import TextField from '../../components/TextField/TextField';
import Loading from '../../components/Loading/Loading';
import EntradaAvulsa from './EntradaAvulsa';

//Api
import destinacaoColeta_api from '../../api/destinacaoColeta_api';

//Helpers
import { showMessage } from '../../helpers/message';
import mascaras from '../../helpers/mascaras';
import { validarCampos, objCampo } from '../../helpers/ValidadorDeCampos';
import uuid from '../../helpers/guid';

//Constants
import { actionsTable } from '../../constants/MaterialTable';
function initialState() {
    return {
        veiculo: "",
        tbOrdemColeta_Id: 0,
        tbDestinosEntradaAvulsa_Id: 0,
        pesoEntrada: "",
        observacao: "",
        origem: "",
        anexos: []
    }
}
export default function EntradaResiduos({ permissao }) {
    const podeEditar = permissao === "Editar";

    //Estado de controle que guarda as destinacoes
    const [destinacoes, setDestinacoes] = useState([]);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle do modal 
    const [openModal, setOpenModal] = useState(false);

    //Estado do item ativo ao clicar em confirmar ou remover
    const [ordemBaixa, setOrdemBaixa] = useState(initialState);

    //Estado de controle da tela de entrada avulsa
    const [entradaAvulsa, setEntradaAvulsa] = useState(false);

    //Controle de exibição do modal na tela
    const toggleModal = () => setOpenModal(!openModal);

    //Estado de controle de exibição do modal de recusa de recebimento de residuos
    const [openModalRecusa, setOpenModalRecusa] = useState(false);

    //Controle de exibição do modal de recusa na tela
    const toggleModalRecusa = (rowData) => {
        if (!openModalRecusa) {
            setOrdemBaixa({
                ...ordemBaixa,
                tbOrdemColeta_Id: rowData.tbOrdemColeta_Id
            });
        }
        setOpenModalRecusa(!openModalRecusa);
    };

    //Estado que guarda os campos que estão incorretos
    const [errors, setErrors] = useState({});

    //Campos obrigatorios para a recusa
    const camposRecusa = [
        objCampo({ name: "observacao", required: true })
    ]

    //Cabeçalhos  da tabela de entrada de residuos
    const headersTabela = [
        { value: "Data", objectValue: "dataColeta" },
        { value: "Veiculo", objectValue: "veiculo" },
        { value: "Modalidade de coleta", objectValue: "modalidadeColeta" },
        { value: "Transportador", objectValue: "transportador" },
    ]

    //Função do botão de confirmar recebimento na tabela
    const confirmarRecebimento = (item, itemKey) => {
        toggleModal();
        const _ordemBaixa = initialState();
        _ordemBaixa.tbOrdemColeta_Id = item.tbOrdemColeta_Id;
        _ordemBaixa.origem = item.origem;
        _ordemBaixa.pesoEntrada = item.pesoEntrada
            ? parseFloat(typeof item.pesoEntrada === "string"
                ? item.pesoEntrada.replace(",", ".")
                : item.pesoEntrada)
            : "0,00";
        _ordemBaixa.veiculo = item.veiculo;
        _ordemBaixa.observacao = "";

        setOrdemBaixa(_ordemBaixa);
    }

    const confirmarEntrada = () => {
        setLoading(true);
        const _ordemBaixa = { ...ordemBaixa };
        if (isNaN(_ordemBaixa.pesoEntrada.replace(",", ".")) && parseFloat(_ordemBaixa.pesoEntrada.replace(",", ".")) == 0) {
            return;
        }
        _ordemBaixa.pesoEntrada = parseFloat(_ordemBaixa.pesoEntrada.replace(",", "."));

        destinacaoColeta_api.AtualizarDestinacao("Entrada", _ordemBaixa).then(response => {
            showMessage("Sucesso", "Entrada confirmada com sucesso!", "success", loadEntradas);
            toggleModal();
            setOrdemBaixa(initialState());
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => {
            setLoading(false);
        })
    }

    //Recusa a ordem escolhida
    const recusaOrdem = () => {
        const _errors = validarCampos(ordemBaixa, camposRecusa);
        setErrors(_errors[0]);
        if (_errors[1].length > 0) {
            return;
        }
        setLoading(true);
        destinacaoColeta_api.RecusaOrdem(ordemBaixa).then(response => {
            showMessage("Sucesso", "Entrada recusada com sucesso!", "success", loadEntradas);
            setOrdemBaixa(initialState());
            toggleModalRecusa();
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false))
    }

    //OnChange para o anexo da recusa da entrada
    const onChangeAnexo = (e) => {
        const anexo = { nome: "", base64: "" };
        anexo.nomeArquivo = e.target.files[0].name;
        anexo.nome = e.target.files[0].name;
        const FR = new FileReader();

        FR.addEventListener("load", function (evt) {
            anexo.base64 = evt.target.result.split("base64,")[1];
            anexo.nome = anexo.nome.split(".");
            anexo.nome = uuid() + "." + anexo.nome[anexo.nome.length - 1];
            setOrdemBaixa({
                ...ordemBaixa,
                anexos: [...ordemBaixa.anexos, anexo]
            });

        });

        FR.readAsDataURL(e.target.files[0]);
    }

    //Remove um dos anexos que foram adicionados
    const removerAnexo = (index) => {
        const _ordemBaixa = {
            ...ordemBaixa
        }
        _ordemBaixa.anexos.splice(index, 1);
        setOrdemBaixa(_ordemBaixa);
    }

    // Carrega todas as entradas disponiveis
    const loadEntradas = () => {
        setLoading(true);
        destinacaoColeta_api.GetList("Entrada").then(response => {
            response.data = response.data.map(value => {
                value.dataColeta = moment(value.dataColeta).format("DD/MM/YYYY");
                return value;
            });
            setDestinacoes(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }
    useEffect(() => {
        loadEntradas();
    }, []);

    //Ações da tabela de listagem
    const actions = podeEditar
        ? [
            actionsTable.remover(toggleModalRecusa),
            actionsTable.confirmar(confirmarRecebimento)
        ]
        : []
    //Controle de exibição da tela de entrada avulsa
    if (entradaAvulsa) {
        return <EntradaAvulsa btnVoltar={() => {
            setEntradaAvulsa(false);
            loadEntradas();
        }} />
    }

    return (
        <MainCard noCard btnCadastro={podeEditar ? "Entrada avulsa" : null} onClickBtnCadastro={() => setEntradaAvulsa(true)}>
            {loading && <Loading />}
            <ModalCustomized title={"Confirmação de entrada de veiculo"} isOpen={openModal} toggle={toggleModal} btnAction={<><FontAwesomeIcon className='me-3' icon={faCheck} />Confirmar</>} btnActionColor={"success"} onClickBtnAction={confirmarEntrada} btnClose>
                <Row>
                    <Col md="12" lg="6">
                        <TextField label={"Veículo"} value={ordemBaixa && ordemBaixa.veiculo} disabled />
                    </Col>
                    <Col md="12" lg="6">
                        <TextField mask={mascaras.floatMask} label={"Peso de entrada (KG)"} name={"pesoEntrada"} value={ordemBaixa.pesoEntrada} onChange={(e) => {
                            setOrdemBaixa({
                                ...ordemBaixa,
                                [e.target.name]: e.target.value
                            });
                        }} invalid={parseFloat(ordemBaixa.pesoEntrada.replace(",", ".")) == 0} />
                    </Col>
                </Row>
            </ModalCustomized>
            <ModalCustomized title={"Recusa de entrada de veículo"} isOpen={openModalRecusa} toggle={toggleModalRecusa} onClickBtnAction={recusaOrdem} btnAction={<><FontAwesomeIcon className='me-3' icon={faCheck} />Confirmar recusa</>} btnActionColor={"success"} btnClose>
                <Row>
                    <Col md="12" lg="12">
                        <TextField label={"Justificativa da recusa"} type="textarea" name={"observacao"} value={ordemBaixa.observacao} onChange={e => { setOrdemBaixa({ ...ordemBaixa, [e.target.name]: e.target.value }) }} invalid={!!errors.observacao} />
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="12">
                        <TextField label={"Anexos"} type="file" name="anexos" onChange={onChangeAnexo} />
                    </Col>
                </Row>
                <Row>
                    {ordemBaixa.anexos.map((value, index) => {
                        return (
                            <Col md="6" lg="2" className='mt-4'>
                                <div className='border text-secondary p-2 shadow d-flex flex-column align-items-center justify-content-center rounded-3 position-relative'>
                                    <button color='danger' className="cancelFileButton" onClick={() => removerAnexo(index)}>
                                        X
                                    </button>
                                    <FontAwesomeIcon size='4x' icon={faFileAlt} />
                                    <p className='m-0 mt-2 fw-bold'>{value.nomeArquivo}</p>
                                </div>
                            </Col>
                        )
                    })}
                </Row>
            </ModalCustomized>
            <TabelaListagem actions={actions} title={"Receber Resíduos - Entrada"} search="Pesquisar na lista" headers={headersTabela} items={destinacoes} options={{ print: false, search: true, pagination: true }} />
        </MainCard>
    )
}